import { Box, Grid, TextField, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  optionInput: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  optionText: {
    width: "17px",
    marginRight: "16px",
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  title: {
    color: theme.palette.primary.main,
    marginBottom: "16px",
    fontWeight: "bold",
  },
}));

export default function TestOption({ text, value, handleChange, type, title }) {
  const classes = useStyles();
  return (
    <Grid item xs={12} md={6}>
      <Box display={title ? "block" : "flex"} alignItems={"center"}>
        <Typography className={title ? classes.title : classes.optionText}>
          {title ? title : text}
        </Typography>
        <TextField
          label={text}
          variant="outlined"
          className={classes.optionInput}
          value={value}
          type={type}
          onChange={(e) => handleChange(e.target.value)}
          onWheel={(e) => e.target.blur()}
        />
      </Box>
    </Grid>
  );
}
